import {
  REMOVE_APPLICATION,
  SET_APPLICATION_INTAKE,
  SET_SELECTED_APPLICATIONS,
  SET_STUDENT_APPLICATIONS_ERROR,
  SET_STUDENT_APPLICATIONS,
} from '../actions/student_applications';

export type IStudentApplicationStoreState = {
  applications: any;
  selectedApplications: Array<any>;
  isLoaded: boolean;
  errors: {
    datesMissing: any;
  };
};

const defaultState: IStudentApplicationStoreState = {
  applications: {},
  selectedApplications: [],
  isLoaded: false,
  errors: {
    datesMissing: false,
  },
};

const setStudentApplications = (state, action): IStudentApplicationStoreState => {
  if (!action.value || !Array.isArray(action.value)) return state;
  const newApps = {};
  action.value.forEach(app => {
    newApps[app.id] = app;
  });
  return {
    ...state,
    isLoaded: true,
    applications: newApps,
  };
};

const setApplicationintake = (state, action) => {
  const { appId } = action;
  const { intake, intakeEsl } = action;
  return {
    ...state,
    applications: {
      ...state.applications,
      [appId]: {
        ...state.applications[appId],
        intake,
        intake_esl: intakeEsl,
      },
    },
  };
};

const removeApplication = (state, action) => {
  const { appId } = action;
  const applications = { ...state.applications };
  delete applications[appId];
  return {
    ...state,
    applications,
  };
};

const reducer = (state = defaultState, action): IStudentApplicationStoreState => {
  if (!action) return state;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case SET_STUDENT_APPLICATIONS:
      return setStudentApplications(state, action);

    case SET_APPLICATION_INTAKE:
      return setApplicationintake(state, action);

    case REMOVE_APPLICATION:
      return removeApplication(state, action);

    case SET_STUDENT_APPLICATIONS_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.key]: action.value,
        },
      };

    case SET_SELECTED_APPLICATIONS:
      return {
        ...state,
        selectedApplications: action.value,
      };

    default:
      break;
  }

  return state;
};

export default reducer;
